.icon {
    width: 64px;
    height: 64px;
    image-rendering: auto;
}

.bigNumber {
    font-size: 2.75rem;
    font-weight: 700;
    line-height: 1;
    color: var(--mantine-color-white);
}

.emptyState {
    color: var(--mantine-color-dark-1);
    font-size: 0.9375rem;
    line-height: 1.4;
    max-width: 18rem;
    text-align: center;
}
